import React from "react";
import { useParams } from "react-router-dom";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

const activityOptions = [
  {
    value: "1",
    label: "Sédentaire (par exemple, travail de bureau mais aussi courses)",
  },
  {
    value: "2",
    label:
      "Légèrement actif (par exemple, promenade de ton chien plusieurs fois par jour ou trajet à vélo)",
  },
  {
    value: "3",
    label:
      "Actif (par exemple, travail à temps plein avec déplacements et en position debout la plupart du temps)",
  },
  {
    value: "4",
    label: "Très actif (par exemple, travail manuel intense)",
  },
];

const niveauStressOptions = [
  {
    value: "1",
    label: "Sans stress (par exemple, en vacances)",
  },
  {
    value: "2",
    label:
      "Occasionnel ou faible stress seulement (par exemple, étudiant en dehors des périodes d'examens)",
  },
  {
    value: "3",
    label:
      "Stress moyen (par exemple, travail à temps plein avec délais et déplacements)",
  },
  {
    value: "4",
    label:
      "Stress élevé (par exemple, environnement de travail très rapide avec grande responsabilité)",
  },
];

const ActivityAndStress = ({ formData, handleInputChange }) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginBottom: "8px" }}>
          Y a-t-il des moments où tu es incapable ou peu disposé à t'entraîner ?
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: "4px", fontStyle: "italic" }}
        >
          Indiquez les moments où vous ne pouvez pas vous entraîner (par
          exemple, pendant les heures de travail, les matins, ou les soirées).
        </Typography>
        <TextField
          label="Moments Impossible d'Entraînement"
          name="entrainementImpossibleMoments"
          value={formData.entrainementImpossibleMoments}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Niveau d'Activité</FormLabel>
          <RadioGroup
            name="niveauActivite"
            value={formData.niveauActivite}
            onChange={handleInputChange}
          >
            {activityOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Niveau de Stress</FormLabel>
          <RadioGroup
            name="niveauStress"
            value={formData.niveauStress}
            onChange={handleInputChange}
          >
            {niveauStressOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginBottom: "8px" }}>
          Comment est ton rythme de sommeil et sa qualité ?
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: "4px", fontStyle: "italic" }}
        >
          Par exemple, coucher entre 22h et 23h / réveil vers 7h30
        </Typography>
        <TextField
          label="Rythme de Sommeil"
          name="rythmeSommeil"
          value={formData.rythmeSommeil}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginBottom: "8px" }}>
          Combien de caféine consommes-tu quotidiennement en moyenne ou lors
          d'une journée de travail ?
        </Typography>
        <TextField
          label="Consommation de Caféine"
          name="cafeine"
          value={formData.cafeine}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginBottom: "8px" }}>
          Quelle option décrit le mieux ton niveau d'engagement ?
        </Typography>
        <TextField
          label="Niveau d'Engagement"
          name="niveauEngagement"
          type="number"
          value={formData.niveauEngagement}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
    </>
  );
};

export default ActivityAndStress;
